// @ts-nocheck
import React from 'react';
import { DatePicker, Input, Select, Row, Col, Form } from 'antd';
import { useEffect } from 'react';
import { useState } from 'react';
import moment from 'moment';

import { fetchCompanyLov, fetchAgentLov } from 'services/accounting_reports/accounting_reports';
import { fetchOrNoListAPI } from 'services/shared/fetchLovList';

const { Option } = Select;
const {RangePicker} = DatePicker;


function LovForm(props) {
	const [form] = Form.useForm();
	const [companyLov, setCompanyLov] = useState([]);
	const [loading, setLoading] = useState();
	const [agentLov, setAgentLov] = useState([]);
	const [orNoLov, setOrNoLov] = useState([]);
	const [customerParam, setcustomerParam] = useState([]);
	const [monthParam, setmonthParam] = useState([]);
	const [yearParam, setyearParam] = useState([]);
	const [dateParam, setdateParam] = useState([]);
	const [agentParam, setagentParam] = useState([]);
	const [weekParam, setweekParam] = useState([]);
	const [asOfDateParam, setAsOfDateParam] = useState([]);

	useEffect(() => {
		async function fetchData() {
			const companyLov = await fetchCompanyLov();
			const agentLov = await fetchAgentLov();
			const orNoList = await fetchOrNoListAPI();

			setCompanyLov(companyLov);
			setAgentLov(agentLov);
			setOrNoLov(orNoList);

			form.resetFields();
		}
		setLoading(true);
		fetchData();
		setLoading(false);
	}, []);

	useEffect(() => {
		//CUSTOMER
		const getCustomer = props.showReport.filter(par => par.parameter_source === 'CUSTOMERS');
		setcustomerParam(getCustomer.length > 0);

		//YEAR
		const getYear = props.showReport.filter(par => par.parameter_source === 'YYYY');
		setyearParam(getYear.length > 0);
		// setyearLabel(getYearLabel);

		//MONTH
		const getMonth = props.showReport.filter(par => par.parameter_source === 'YYYYMM');
		setmonthParam(getMonth.length > 0);
		// setmonthLabel(getMonthLabel);

		//DATE
		const getDate = props.showReport.filter(par => par.parameter_source === 'CALENDAR');
		setdateParam(getDate.length > 0);
		// setdateLabel(getDateLabel);

		//AGENT
		const getAgent = props.showReport.filter(par => par.parameter_source === 'AGENTS');
		setagentParam(getAgent.length > 0);
		// setagentLabel(getAgentLabel);

		//WEEK
		const getWeek = props.showReport.filter(par => par.parameter_source === 'YYYY_WW');
		setweekParam(getWeek.length > 0);

		//asOfDate
		const getAsOfDate = props.showReport.filter(par => par.parameter_source === 'AS_OF_DATE');
		setAsOfDateParam(getAsOfDate.length > 0);
		// console.log('props ', props);
	});

	//get customer list
	const companyOptions = companyLov.map((item, index) => {
		return (
			<Option key={index} value={item.customer_id}>
				{item.customer}
			</Option>
		);
	});

	//get company list
	const agentOptions = agentLov.map((item, index) => {
		return (
			<Option key={index} value={item.agent_code}>
				{item.agent}
			</Option>
		);
	});

    //get or_no list
    const orNoOptions = orNoLov.map((item, index) => {
        return(
            <Option key={item.payment_id} value={item.or_no}>{item.or_no}</Option>
        );
    });

	const onChangeCustomer = value => {
		props.paramCustomer(value);
	};
	const onChangeAgent = value => {
		props.paramAgent(value);
	};
	const onChangeYear = value => {
		if(value){
			props.paramYear(moment(value).format('YYYY'));
		}else{
			props.paramYear(value);
		}
	};
	const onChangeMonth = value => {
		if(value){
			props.paramMonYear(moment(value).format('YYYYMM'));
		}else{
			props.paramMonYear(value);
		}
	};
	const onChangeDate = value => {
		props.paramDate(moment(value).format('YYYYMMDD'));
	};
	const onChangeWeek = (value) => {
		if(value){ // catches null value error
			props.paramWeek(`${value.startOf('week').format('YYYY-MM-DD')}~${value.endOf('week').format('YYYY-MM-DD')}`);
		}else{
			props.paramWeek(value);
		}
	};

	const onChangeAsOfDate = value => {
		// console.log('lov value => ', value);
		if(value){
			props.paramAsOfDate(moment(value).format('YYYY-MM-DD'));
		}else{
			props.paramAsOfDate(value);
		}
	}

	const onChangeDateRange = value => {
		// console.log('lov value => ', value);
		if(value){
			props.paramDateRange(value);
		}else{
			props.paramDateRange(value);
		}
	}

	const onChangeOrNo = value => {
		// console.log('lov value => ', value);
		if(value){
			props.paramOrNo(value);
		}else{
			props.paramOrNo(value);
		}
	}

    const disabledDate = (current) => {
        // Can not select future dates
        return current > moment().endOf('day') || current > moment().endOf('day');
    };

	const customFormatDate = value => 
		`${value.startOf('week').format('YYYY-MM-DD')}~${value.endOf('week').format('YYYY-MM-DD')}`;

	return (
		<div className="form-lov">
			<Row gutter={[8, 1]}>
				{customerParam ? (
					<Col span={6}>
						<Form.Item label={props.customerLabel} name='customer' rules={[{ required: true, message: 'Required Field' }]}>
							<Select
								style={{ width: '100%' }}
								placeholder="CUSTOMER"
								showSearch
								onChange={onChangeCustomer}
								filterOption={(input, option) =>
									option.children.toLowerCase().includes(input.toLowerCase())
								}
							>
								{companyOptions}
							</Select>
						</Form.Item>
					</Col>
				) : null}
				{agentParam ? (
					<Col span={6}>
						<Form.Item label={props.agentLabel} name='agent' rules={[{ required: true, message: 'Required Field' }]}>
							<Select
								style={{ width: '100%' }}
								placeholder="AGENT"
								showSearch
								filterOption={(input, option) =>
									option.children.toLowerCase().includes(input.toLowerCase())
								}
								onChange={onChangeAgent}
							>
								{agentOptions}
							</Select>
						</Form.Item>
					</Col>
				) : null}
				{monthParam ? (
					<Col span={6}>
						<Form.Item label={props.monthLabel} name='monthYear' rules={[{ required: true, message: 'Required Field' }]}>
							<DatePicker picker="month" style={{ width: '100%' }} onChange={onChangeMonth} />
						</Form.Item>
					</Col>
				) : null}
				{yearParam ? (
					<Col span={6}>
						<Form.Item label={props.yearLabel} name='year' rules={[{ required: true, message: 'Required Field' }]}>
							<DatePicker picker="year" style={{ width: '100%' }} onChange={onChangeYear} />
						</Form.Item>
					</Col>
				) : null}
				{dateParam ? (
					<Col span={6}>
						<Form.Item label={props.dateLabel} name='date' rules={[{ required: true, message: 'Required Field' }]}>
							<DatePicker style={{ width: '100%' }} onChange={onChangeDate} />
						</Form.Item>
					</Col>
				) : null}
				{weekParam ? (
					<Col span={6}>
						<Form.Item label={props.weekLabel} name='week' rules={[{ required: true, message: 'Required Field' }]}>
							<DatePicker 
								onChange={onChangeWeek} 
								picker="week" 
								style={{ width: '100%' }} 
								format={customFormatDate}
							/>
						</Form.Item>
					</Col>
				) : null}
				{/* as of date */}
				{asOfDateParam ? (
					<Col span={6}>
					<Form.Item label={props.asOfDateLabel} name='asOfDate' rules={[{ required: true, message: 'Required Field' }]}>
						<DatePicker onChange={onChangeAsOfDate} style={{ width: '100%' }} />
					</Form.Item>
				</Col>
				) : null}
				{/* date range */}
				{props.reportType !== undefined && props.reportType !== 2
					?	<Col span={8}>
							<Form.Item label='DATE RANGE' name="dateRange" rules={[{ required: true, message: 'Required Field' }]}
                                // initialValue={[moment.utc(), moment.utc()]}
							>
								{/* @ts-ignore */}
								<RangePicker 
									format={"MM-DD-YYYY"} 
									onChange={onChangeDateRange}
									// defaultValue={[moment.utc(), moment.utc()]}
									disabledDate={disabledDate}
									placeholder={["MM-DD-YYYY", "MM-DD-YYYY"]}
								/>
							</Form.Item>
						</Col>
					:	null
				}
			</Row>
		</div>
	);
};

export default LovForm;
